// Typed access to content/site.json: the copy both apps must say identically -
// the brand, the button labels, the legal line. Page-specific copy stays in its app.
import site from "../content/site.json";

/**
 * Addresses of things that are not this deployment - the Discord, the repositories, the
 * parent company. They belong here rather than in an environment variable: they are the
 * same in every deployment, and they were previously repeated in five files.
 */
export interface SiteLinks {
  discord: string;
  github: string;
  githubOrg: string;
  compressor: string;
  dendrite: string;
}

export interface SiteCopy {
  brand: string;
  navAria: string;
  docs: string;
  dashboard: string;
  openApp: string;
  menu: { open: string; close: string };
  theme: { aria: string; light: string; dark: string };
  /** Accessible names for the two icon links at the end of the header. */
  community: string;
  repository: string;
  labs: string;
  contact: string;
  dendrite: string;
  /** The products menu. Hrefs carry {appUrl} and {compressor}, resolved in SiteNav. */
  tools: {
    label: string;
    items: { label: string; description: string; href: string; external?: boolean }[];
  };
  footer: { tagline: string; legal: string };
  links: SiteLinks;
}

export const siteCopy = site as SiteCopy;
